export default __webpack_public_path__ + "static/media/DtVmJx26TKEr37c9YK5silss6yLUrwA.f77a9c3a.woff2";